<script  lang="ts">
  import AddPlayer from "@frontend/Components/AddPlayer.svelte";
  import Modal from "@frontend/Components/Modal.svelte";
  import WithdrawDepositForm from "@frontend/Components/WithdrawDepositForm.svelte";
  import WithdrawCashierForm from "@frontend/Components/WithdrawCashierForm.svelte";
  import { service } from "@frontend/services";
  import { GetCachedToken, me, RefreshMe } from "@frontend/user";
  import { type ApiResultOfPublicUserDTO, type User, type WalletTransaction, UserRole, type PublicUserDTO } from "@frontend/walletapi";
  import { onMount } from "svelte";
  import { push, location } from "svelte-spa-router";
  import EditPlayerForm from "../Components/EditPlayerForm.svelte";
  import { formatDate, formatMoney } from "./Formats";
  import { usersByRole, RefreshUsers } from "@frontend/userlist";
  import { get } from "svelte/store";
  import { fade } from 'svelte/transition';
  import EditUserForm from "@frontend/Components/EditUserForm.svelte";
  import { Transactions } from "@frontend/Transactionlist";
  import PromotionalcreditsForm from "@frontend/Components/PromotionalcreditsForm.svelte";
  import { translate, currentLanguage } from "../Translator";
  import { groups } from "@frontend/grouplist";


  let currentPage = 1;
  let playersPerPage = 10;
  let paginatedPlayers: User[] = [];
  let lastKnownPage = 1; 
  let isNavigatingProgrammatically = false; 
  
 
  function updateUrlWithPage(page: number) {
    isNavigatingProgrammatically = true;
    const pageQuery = page > 1 ? `?page=${page}` : '';
    push(`#/PlayerList${pageQuery}`);
    setTimeout(() => {
      isNavigatingProgrammatically = false;
    }, 100);
  }
  
  
  type PromoAction =
  {
    action: "promo",
    userid: number
  };

  type WithdrawAction =
  {
    action: "withdraw",
    userid: number
  };

  type WithdrawcashierAction =
  {
    action: "withdrawcashier",
    userid: number
  };


  type DepositAction =
  {
    action: "deposit",
    userid: number;
  };

  type EditAction =
  {
    action: "edit",
    userid: number;
  };

  type AddAction =
  {
    action: "add"
  };

  type RouteParams =
    WithdrawAction |
    WithdrawcashierAction |
    DepositAction |
    EditAction |
    AddAction |
    PromoAction |
    undefined;



  export let params: RouteParams = undefined;

  let selectedUser: User | undefined = undefined;
  $: if (params)
  {
    if (params.action == "deposit" ||
      params.action == "promo" ||
      params.action == "withdraw" ||
      params.action == "withdrawcashier" || 
      params.action == "edit")
    {
      let selectedUserId = params.userid;
      selectedUser = get(usersByRole[UserRole.Player]).find(p => p.Id == selectedUserId);
    }
  }

  let allPlayers: User[] = [];
  let searchPlayers: User[] = [];
  let searchInput: string = "";

  let message = { text: '', type: '' };

  onMount(() => {
    if (!$me) {
      push("/user/Login");
    }
    
    // Leer parámetro de página desde el hash
    const hash = window.location.hash;
    const hashParts = hash.split('?');
    let pageParam = null;
    
    if (hashParts.length > 1) {
      const hashQueryParams = new URLSearchParams(hashParts[1]);
      pageParam = hashQueryParams.get('page');
    }
    
    if (pageParam) {
      const pageNumber = parseInt(pageParam, 10);
      if (pageNumber > 0) {
        console.log('onMount: Setting currentPage from', currentPage, 'to', pageNumber);
        currentPage = pageNumber;
        lastKnownPage = pageNumber;
      }
    }
  });

  // Reactivo para leer página cuando cambie la URL
  $: {
    if ($location && !isNavigatingProgrammatically) {
      // Leer parámetro de página desde el hash (no desde search)
      const hash = window.location.hash;
      const hashParts = hash.split('?');
      let pageParam = null;
      
      if (hashParts.length > 1) {
        const hashQueryParams = new URLSearchParams(hashParts[1]);
        pageParam = hashQueryParams.get('page');
      }
      
      console.log('REACTIVE: URL=', $location, 'Hash=', hash, 'PageParam=', pageParam, 'CurrentPage=', currentPage);
      
      if (pageParam) {
        const pageNumber = parseInt(pageParam, 10);
        if (pageNumber > 0 && pageNumber !== currentPage) {
          console.log('REACTIVE: Updating currentPage from', currentPage, 'to', pageNumber);
          currentPage = pageNumber;
          lastKnownPage = pageNumber;
          console.log('REACTIVE: currentPage is now', currentPage);
        }
      } else {
        // Solo resetear si estamos en la página base sin modales
        if ($location === '/PlayerList' && !params?.action) {
          if (currentPage !== 1) {
            console.log('REACTIVE: Resetting to page 1');
            currentPage = 1;
            lastKnownPage = 1;
          }
        } else {
          // Mantener la última página conocida cuando estamos en un modal
          if (currentPage !== lastKnownPage) {
            console.log('REACTIVE: Keeping lastKnownPage', lastKnownPage);
            currentPage = lastKnownPage;
          }
        }
      }
    }
  }

  onMount(async () => {
    await RefreshUsers();
    

    setTimeout(() => {
      checkForExpiredPromotions();
    }, 1000); 
    
  
    const expirationCheckInterval = setInterval(() => {
      checkForExpiredPromotions();
    }, 60000);
    

    return () => {
      clearInterval(expirationCheckInterval);
    };
  });


  usersByRole[UserRole.Player].subscribe((players) => {
    allPlayers = players;
  
    updatePlayersWithoutResettingPage();
  });

  $: {
    if ($Transactions.length > 0) {
      setTimeout(() => {
        usersByRole[UserRole.Player].update(players => {
          let hasUpdates = false;
          const updatedPlayers = players.map(player => {
            const playerTransactions = $Transactions.filter(t => t.UserId === player.Id);
            const lastTransaction = playerTransactions.length > 0 ? playerTransactions[0] : null;
            
            if (lastTransaction) {
              const currentPromotions = player.LastWalletTransaction?.PromotionTransactions || [];
              const newPromotions = lastTransaction.PromotionTransactions || [];
              
              const validPromotions = newPromotions.filter(promo => {
                const now = new Date();
                const expirationDate = new Date(promo.ExpirationDate);
                const hasValidBalance = (promo.Balance?.InCents || 0) > 0;
                const isNotExpired = expirationDate > now;
                
                if (!hasValidBalance || !isNotExpired) {
                }
                
                return hasValidBalance && isNotExpired;
              });
              
              const finalPromotions = validPromotions.length > 0 ? validPromotions : [];
              
              const promotionsChanged = JSON.stringify(currentPromotions) !== JSON.stringify(validPromotions);
              const transactionIdChanged = player.LastWalletTransactionId !== lastTransaction.Id;
              const balanceChanged = player.LastWalletTransaction?.CashableBalance?.InCents !== lastTransaction.CashableBalance?.InCents;
              
              if (newPromotions.length > 0) {
              }
              
              if (promotionsChanged || transactionIdChanged || balanceChanged) {
                hasUpdates = true;
                return {
                  ...player,
                  LastWalletTransactionId: lastTransaction.Id,
                  LastWalletTransaction: {
                    ...lastTransaction,
                    PromotionTransactions: finalPromotions
                  }
                };
              }
            }
            return player;
          });
          
          if (hasUpdates) {
            return updatedPlayers;
          }
          
          return players; // No hay cambios, devolver la lista original
        });
      }, 0);
    }
  }

  function updatePagination() {
    console.log('updatePagination: currentPage =', currentPage, 'searchPlayers.length =', searchPlayers.length);
    const startIndex = (currentPage - 1) * playersPerPage;
    const endIndex = startIndex + playersPerPage;
    paginatedPlayers = searchPlayers.slice(startIndex, endIndex);
    console.log('updatePagination: showing players', startIndex, 'to', endIndex, 'total:', paginatedPlayers.length);
  }

  function getTotalPages(): number {
    return Math.ceil(searchPlayers.length / playersPerPage);
  }

  function goToPage(page: number) {
    console.log('goToPage called with page:', page, 'currentPage was:', currentPage);
    if (page >= 1 && page <= getTotalPages()) {
      currentPage = page;
      lastKnownPage = page;
      console.log('goToPage: currentPage is now', currentPage);
      updatePagination();
      updateUrlWithPage(page);
    }
  }

  function previousPage() {
    if (currentPage > 1) {
      goToPage(currentPage - 1);
    }
  }

  function nextPage() {
    if (currentPage < getTotalPages()) {
      goToPage(currentPage + 1);
    }
  }

  function getPageRange() {
    const totalPages = getTotalPages();
    const current = currentPage;
    const delta = 2; // Número de páginas a mostrar antes y después de la página actual
    
    let start = Math.max(1, current - delta);
    let end = Math.min(totalPages, current + delta);
    
    if (end - start < 4) {
      if (start === 1) {
        end = Math.min(totalPages, start + 4);
      } else {
        start = Math.max(1, end - 4);
      }
    }
    
    return Array.from({length: end - start + 1}, (_, i) => start + i);
  }

  function isPlayerInUserHierarchy(player: User, user: User): boolean {
    if (!player.GroupId || !user.GroupId) {
      return false;
    }

    if (player.GroupId === user.GroupId) {
      return true;
    }

    const userGroup = $groups.find(g => g.Id === user.GroupId);
    if (userGroup?.ParentId && player.GroupId === userGroup.ParentId) {
      return true;
    }

    if (player.Group?.ParentId === user.GroupId) {
      return true;
    }

    let currentGroup = player.Group;
    while (currentGroup?.ParentId) {
      if (currentGroup.ParentId === user.GroupId) {
        return true;
      }
      currentGroup = $groups.find(g => g.Id === currentGroup?.ParentId);
    }

    return false;
  }

  function isPlayerInCashierHierarchy(player: User, cashier: User): boolean {
    if (!player.GroupId || !cashier.GroupId) {
      return false;
    }

    const playerGroupId = Number(player.GroupId);
    const cashierGroupId = Number(cashier.GroupId);

    if (playerGroupId === cashierGroupId) {
      return true;
    }

    const cashierGroup = $groups.find(g => g.Id === cashierGroupId);
    if (cashierGroup?.ParentId && playerGroupId === Number(cashierGroup.ParentId)) {
      return true;
    }

    if (cashierGroup?.ParentId) {
      const siblingGroups = $groups.filter(g => g.ParentId === cashierGroup.ParentId);
      const siblingGroupIds = siblingGroups.map(g => g.Id);
      if (siblingGroupIds.includes(playerGroupId)) {
        return true;
      }
    }

    if (player.Group?.ParentId === cashierGroupId) {
      return true;
    }

    let currentGroup = player.Group;
    while (currentGroup?.ParentId) {
      if (Number(currentGroup.ParentId) === cashierGroupId) {
        return true;
      }
      currentGroup = $groups.find(g => g.Id === currentGroup?.ParentId);
    }

    return false;
  }

  function filterPlayers()
  {

    let filteredByGroup = allPlayers;
    
    if ($me?.Role === UserRole.Admin) {
      filteredByGroup = allPlayers.filter(player => {
        const isInHierarchy = isPlayerInUserHierarchy(player, $me);
        return isInHierarchy;
      });
    } else if ($me?.Role === UserRole.Cashier) {
      filteredByGroup = allPlayers.filter(player => {
        const isInHierarchy = isPlayerInCashierHierarchy(player, $me);
        return isInHierarchy;
      });
    } else if ($me?.Role === UserRole.Owner) {
      filteredByGroup = allPlayers;
    }

    if (searchInput == '')
    {
      searchPlayers = filteredByGroup;
    }
    else
    {
      let searchInputNormalized = searchInput.toLowerCase();
      searchPlayers = filteredByGroup.filter((player) =>
        player?.Id?.toString().toLowerCase()?.includes(searchInputNormalized) ||
        player?.Role?.toString().toLowerCase()?.includes(searchInputNormalized) ||
        player?.Email?.toLowerCase()?.includes(searchInputNormalized) ||
        player?.FirstName?.toLowerCase()?.includes(searchInputNormalized) ||
        player?.LastName?.toLowerCase()?.includes(searchInputNormalized)
      );
    }
    
    const totalPages = Math.ceil(searchPlayers.length / playersPerPage);
    if (currentPage > totalPages && totalPages > 0) {
      currentPage = totalPages;
    }
    // No resetear currentPage a 1 automáticamente - dejar que la URL lo maneje
    updatePagination();
  }

  function updatePlayersWithoutResettingPage()
  {
    let filteredByGroup = allPlayers;
    
    if ($me?.Role === UserRole.Admin) {
      filteredByGroup = allPlayers.filter(player => {
        const isInHierarchy = isPlayerInUserHierarchy(player, $me);
        return isInHierarchy;
      });
    } else if ($me?.Role === UserRole.Cashier) {
      filteredByGroup = allPlayers.filter(player => {
        const isInHierarchy = isPlayerInCashierHierarchy(player, $me);
        return isInHierarchy;
      });
    } else if ($me?.Role === UserRole.Owner) {
      filteredByGroup = allPlayers;
    }

    if (searchInput == '')
    {
      searchPlayers = filteredByGroup;
    }
    else
    {
      let searchInputNormalized = searchInput.toLowerCase();
      searchPlayers = filteredByGroup.filter((player) =>
        player?.Id?.toString().toLowerCase()?.includes(searchInputNormalized) ||
        player?.Role?.toString().toLowerCase()?.includes(searchInputNormalized) ||
        player?.Email?.toLowerCase()?.includes(searchInputNormalized) ||
        player?.FirstName?.toLowerCase()?.includes(searchInputNormalized) ||
        player?.LastName?.toLowerCase()?.includes(searchInputNormalized)
      );
    }
    
    updatePagination();
  }

  function dismiss()
  {
    const pageQuery = currentPage > 1 ? `?page=${currentPage}` : '';
    push(`#/PlayerList${pageQuery}`);
  }




  $: {
    searchInput;
    searchChanged();
  }

  function clearSearch() {
    searchInput = '';
  }


  let searchTimer: number = 0;
  function searchChanged()
  {
    if (searchTimer != 0) window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(applySearch, 500)
  }

  function applySearch()
  {
    searchTimer = 0;
    filterPlayers();
  }

  function IsSearchAndNoPlayersMatch(searchPlayes: User[])
  {
    if (searchInput && searchPlayers.length == 0)
    {
      return true;
    }

    return false;
  }

  function IsSearch(searchInput: string)
  {
    return searchInput && searchInput.length > 0;
  }

  async function DisablePlayer(user: User) {
    try {
      user.Enabled = !user.Enabled;
      
      const result = await service.walletapi.disableUser({
        Token: GetCachedToken(),
        Data: {
          Enabled: user.Enabled,
          Id: user.Id
        }
      });

      if (result.Success) {
        const players = get(usersByRole[UserRole.Player]);
        const updatedPlayers = players.map(p => 
          p.Id === user.Id ? { ...p, Enabled: user.Enabled } : p
        );
        usersByRole[UserRole.Player].set(updatedPlayers);

        message = {
          text: `Player ${user.FirstName} has been ${user.Enabled ? 'enabled' : 'disabled'} successfully`,
          type: user.Enabled ? 'success' : 'negative'
        };
      } else {
        user.Enabled = !user.Enabled;
        message = {
          text: result.Message || 'Error updating player status',
          type: 'error'
        };
      }
    } catch (err) {
      // Si hay error, revertir el cambio
      user.Enabled = !user.Enabled;
      message = {
        text: err instanceof Error ? err.message : 'An unexpected error occurred',
        type: 'error'
      };
    }

    setTimeout(() => {
      message = { text: '', type: '' };
    }, 3000);
  }

  function CanWithdraw(lastTransaction: WalletTransaction | undefined): boolean
  {
    if (!lastTransaction)
    {
      return false;
    }

    const moneyTransactionBalance = lastTransaction.MoneyTransaction?.[0]?.Balance?.InCents ?? 0;
    if (moneyTransactionBalance > 0)
    {
      return true;
    }

    const cashableBalance = lastTransaction.CashableBalance?.InCents ?? 0;
    if (cashableBalance > 0)
    {
      return true;
    }

    return false;
  }

  function CanDeposit(user: User): boolean
  {
    if (!user.Enabled)
    {
      return false;
    }

    return true;
  }

  function CanWithdrawForUser(user: User, lastTransaction: WalletTransaction | undefined): boolean
  {
    if (!user.Enabled)
    {
      return false;
    }

    return CanWithdraw(lastTransaction);
  }

  function sumPromotionBalances(promoArr: any[]) {
    if (!promoArr || promoArr.length === 0) return 0;
    return promoArr.reduce((sum: number, promo: any) => sum + (promo.Balance?.InCents || 0), 0);
  }

  function checkForExpiredPromotions() {
    usersByRole[UserRole.Player].update(players => {
      let hasUpdates = false;
      const updatedPlayers = players.map(player => {
        const currentPromotions = player.LastWalletTransaction?.PromotionTransactions || [];
        
        if (currentPromotions.length > 0) {
          const validPromotions = currentPromotions.filter(promo => {
            const now = new Date();
            const expirationDate = new Date(promo.ExpirationDate);
            const hasValidBalance = (promo.Balance?.InCents || 0) > 0;
            const isNotExpired = expirationDate > now;
            
            if (!hasValidBalance || !isNotExpired) {
            }
            
            return hasValidBalance && isNotExpired;
          });
          
          if (validPromotions.length !== currentPromotions.length) {
          }
        }
        
        return player;
      });
      
      if (hasUpdates) {
        return updatedPlayers;
      }
      
      return players;
    });
  }

  function getGroupPath(group: any): string {
    if (!group) return '';
    
    let path = group.Name;
    let currentGroup = group;
    
    while (currentGroup.ParentId) {
      const parentGroup = $groups.find(g => g.Id === currentGroup.ParentId);
      if (parentGroup) {
        path = parentGroup.Name + '/' + path;
        currentGroup = parentGroup;
      } else {
        break;
      }
    }
    
    return path;
  }

</script>


<h1 class="ui centered dividing header">{$translate('List of players')} ({searchPlayers?.length ?? ""})</h1>


<div class="ui action input">
  <input type="text" bind:value={searchInput} placeholder={$translate('Player name')}  autocomplete="off">
  <button class="ui icon button" on:click={clearSearch}>
    <i class="times icon"></i>
  </button>
</div>
{#if params?.action == "promo"}
  <Modal dismiss={dismiss}>
    {#if !selectedUser}
      <div class="ui negative message" on:click={dismiss}>
        <i class="close icon"></i>
        <div class="header">
          {$translate('No such User')}
        </div>
        <p>Player with id {params?.userid ?? "?"}  {$translate('does not exist')}</p>
      </div>
    {:else}
      <PromotionalcreditsForm player={selectedUser} dismiss={dismiss} type="promo"></PromotionalcreditsForm>
    {/if}
  </Modal>
{/if}
{#if params?.action == "deposit"}
  <Modal dismiss={dismiss}>
    {#if !selectedUser}
      <div class="ui negative message" on:click={dismiss}>
        <i class="close icon"></i>
        <div class="header">
          {$translate('No such User')}
        </div>
        <p>Player with id {params?.userid ?? "?"} {$translate('does not exist')}</p>
      </div>
    {:else if !CanDeposit(selectedUser)}
      <div class="ui negative message">
        <i class="close icon" on:click={dismiss}></i>
        <div class="header">
          {$translate('User Disabled')}
        </div>
        <p>{$translate('Cannot make deposits for disabled users')}</p>
        <button class="ui button" on:click={dismiss}>{$translate('Close')}</button>
      </div>
    {:else}
      <WithdrawDepositForm player={selectedUser} dismiss={dismiss} type="deposit"></WithdrawDepositForm>
    {/if}
  </Modal>
{/if}

{#if params?.action == "withdraw"}
  <Modal dismiss={dismiss}>
    {#if !selectedUser}
      <div class="ui negative message">
        <div class="header">{$translate('No such User')}</div>
      </div>
    {:else if !CanWithdrawForUser(selectedUser, selectedUser.LastWalletTransaction)}
      <div class="ui negative message">
        <i class="close icon" on:click={dismiss}></i>
        <div class="header">
          {$translate('User Disabled or No Balance')}
        </div>
        <p>{$translate('Cannot make withdrawals for disabled users or users without balance')}</p>
        <button class="ui button" on:click={dismiss}>{$translate('Close')}</button>
      </div>
    {:else}
      <WithdrawDepositForm player={selectedUser} dismiss={dismiss} type="withdraw"></WithdrawDepositForm>
    {/if}
  </Modal>
{/if}

{#if params?.action == "withdrawcashier"}
  <Modal dismiss={dismiss}>
    {#if !selectedUser}
      <div class="ui negative message">
        <div class="header">{$translate('No such User')}</div>
      </div>
    {:else if !CanWithdrawForUser(selectedUser, selectedUser.LastWalletTransaction)}
      <div class="ui negative message">
        <i class="close icon" on:click={dismiss}></i>
        <div class="header">
          {$translate('User Disabled or No Balance')}
        </div>
        <p>{$translate('Cannot make withdrawals for disabled users or users without balance')}</p>
        <button class="ui button" on:click={dismiss}>{$translate('Close')}</button>
      </div>
    {:else}
      <WithdrawCashierForm player={selectedUser} dismiss={dismiss}></WithdrawCashierForm>
    {/if}
  </Modal>
{/if}

{#if params?.action == "add"}
  <Modal dismiss={dismiss} size="large">
    <AddPlayer dismiss={dismiss}></AddPlayer>
  </Modal>
{/if}

{#if params?.action == "edit"}
  <Modal dismiss={dismiss} size="large">
    {#if !selectedUser}
      <div class="ui negative message">
        <div class="header">{$translate('No such User')}</div>
      </div>
    {:else}
      <EditUserForm user={selectedUser} dismiss={dismiss}></EditUserForm>
    {/if}
  </Modal>
{/if}

{#if IsSearchAndNoPlayersMatch(searchPlayers)}
  <div class="ui negative message">
    <div class="header">{$translate('No players found')}</div>
  </div>
{:else}

<a href="#/PlayerList/add" class="ui green button">
  <i class="user plus icon"></i>
 {$translate('Add player')}
</a> 
<div style="overflow-x: auto;">
<table class="playerlist ui celled unstackable striped selectable very compact unselectable table">
  <thead>
    <tr>
      <th style="width: 0px">#</th>
      <th>{$translate('First Name')}</th>
      <th>{$translate('E-mail')}</th>
      <th>{$translate('Phone Number')}</th>
      <th>{$translate('Birthday')}</th>
      <th>{$translate('Group')}</th>
      <th>{$translate('Promo')}</th>
      <th>{$translate('Balance')}</th>
      <th>{$translate('Total')}</th>
      <th style="width: 0px">Allow</th>
      <th style="width: 200px">{$translate('Options')}</th>
    </tr>
  </thead>
  <tbody>
    {#each paginatedPlayers as user}
      <tr>
        <td class="numeric">{user.Id}</td>
        <td class="name-column" title="{user.FirstName} {user.LastName}">
          {user.FirstName} {user.LastName}
        </td>
        <td class="email-column" title={user.Email}>
          {user.Email ?? ""}
        </td>
        <td class="phone-column" title={user.PhoneNumber}>
          {user.PhoneNumber ?? ""}
        </td>
        <td class="phone-column" title={user.BirthdayDay?.toString()}>
         {formatDate(user.BirthdayDay)}
        </td>
        <td class="group-column" title={getGroupPath(user.Group)}>
          {#if user.Group?.Id === $me?.GroupId}
            <span class="my-group-badge">📁 {getGroupPath(user.Group)}</span>
          {:else if user.Group?.ParentId === $me?.GroupId}
            <span class="child-group-badge">└─ {getGroupPath(user.Group)}</span>
          {:else if $groups.find(g => g.Id === $me?.GroupId)?.ParentId === user.Group?.Id}
            <span class="parent-group-badge">⬆️ {getGroupPath(user.Group)}</span>
          {:else if isPlayerInUserHierarchy(user, $me)}
            <span class="hierarchy-group-badge">🔗 {getGroupPath(user.Group)}</span>
          {:else}
            <span class="other-group-badge">{getGroupPath(user.Group)}</span>
          {/if}
        </td>
        <td class="numeric balance-column">
          {formatMoney(sumPromotionBalances(user.LastWalletTransaction?.PromotionTransactions || []))}
        </td>
        <td class="numeric balance-column">
         {formatMoney(user.LastWalletTransaction?.MoneyTransaction?.[0]?.Balance|| 0)}
        </td>
        <td class="numeric balance-column">
          {formatMoney(user.LastWalletTransaction?.CashableBalance || 0)}
        </td>
        <td>
          <button class={`ui icon small button ${user.Enabled ? 'positive' : 'negative'}`} on:click={() => DisablePlayer(user)}>
            {#if user.Enabled}
              <i class="check icon"></i>
            {:else}
              <i class="close icon"></i>
            {/if}
          </button>
        </td>
        <td>
          <div style="display: inline-flex; flex-wrap: nowrap; gap: 4px;">
            <button class="ui positive small button" class:disabled={!CanDeposit(user)} on:click={() => push(`#/PlayerList/deposit/${user.Id}?page=${currentPage}`)}>{$translate('Deposit')}</button>
            {#if $me?.Role === 'Cashier'}
              <a class="ui negative small button" class:disabled={!CanWithdrawForUser(user, user.LastWalletTransaction)} href={`#/PlayerList/withdrawcashier/${user.Id}?page=${currentPage}`}>{$translate('Withdraw')}</a>
            {:else}
              <a class="ui negative small button" class:disabled={!CanWithdrawForUser(user, user.LastWalletTransaction)} href={`#/PlayerList/withdraw/${user.Id}?page=${currentPage}`}>{$translate('Withdraw')}</a>
            {/if}
            <a class="ui teal small button" href="#/UserbyTransaction/view/{user.Id}">{$translate('Transactions')}</a>
            <a class="ui primary icon small button" href={`#/playerlist/edit/${user.Id}?page=${currentPage}`}>
              <i class="edit icon"></i>
            </a>
          </div>
        </td>
      </tr>
    {/each}
  </tbody>
</table>
</div>

{#if getTotalPages() > 1}
  <div class="ui pagination menu" style="justify-content: center; margin-top: 1em;">
    <a class="icon item" class:disabled={currentPage === 1} on:click={previousPage}>
      <i class="left chevron icon"></i>
    </a>
    
    {#if currentPage > 3}
      <a class="item" on:click={() => goToPage(1)}>1</a>
      {#if currentPage > 4}
        <div class="disabled item">...</div>
      {/if}
    {/if}
    
    {#each getPageRange() as page}
      <a class="item" class:active={page === currentPage} on:click={() => goToPage(page)}>
        {page}
      </a>
    {/each}
    
    {#if currentPage < getTotalPages() - 2}
      {#if currentPage < getTotalPages() - 3}
        <div class="disabled item">...</div>
      {/if}
      <a class="item" on:click={() => goToPage(getTotalPages())}>{getTotalPages()}</a>
    {/if}
    
    <a class="icon item" class:disabled={currentPage === getTotalPages()} on:click={nextPage}>
      <i class="right chevron icon"></i>
    </a>
  </div>
  
  <div class="ui center aligned text" style="margin-top: 0.5em; color: #666;">
    Mostrando {((currentPage - 1) * playersPerPage) + 1} - {Math.min(currentPage * playersPerPage, searchPlayers.length)} de {searchPlayers.length} jugadores
  </div>
{/if}
{/if}

{#if message.text}
  <div class="ui message {message.type === 'success' ? 'positive' : 'negative'}" transition:fade>
    <i class="close icon" on:click={() => message = { text: '', type: '' }}></i>
    <div class="header">
      {#if message.type === 'success'}
        <i class="check circle icon"></i> Success
      {:else if message.type === 'negative'}
        <i class="ban icon"></i> Player Disabled
      {:else}
        <i class="exclamation triangle icon"></i> Error
      {/if}
    </div>
    <p>{message.text}</p>
  </div>
{/if}

<style>
  .center{
    text-align: center;
  }

  .ui.input {
    margin-bottom: 1em;
  }

  .playerlist {
    white-space: nowrap;
    font-size: 0.85em !important;
  }

  .playerlist td {
    padding: 0.4em !important;
    text-align: center;
  }

  .playerlist th {
    padding: 0.3em 0.4em !important;
    text-align: center;
  }

  .numeric {
    font-family: monospace;
    text-align: right !important;
  }

  .ui.small.button {
    padding: 0.6em 0.8em !important;
    font-size: 0.85em !important;
    margin: 0 !important;
  }

  .ui.table td {
    padding: 0.3em !important;
  }

  /* Ajustar anchos de columnas específicas */
  .id-column {
    width: 40px !important;
  }

  .name-column {
    width: 100px !important;
  }

  .email-column {
    width: 150px !important;
  }

  .phone-column {
    width: 80px !important;
  }

  .balance-column {
    width: 70px !important;
  }

  .group-column {
    width: 180px !important;
    text-align: left !important;
    max-width: 180px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .my-group-badge {
    background-color: #e3f2fd;
    color: #1976d2;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.8em;
    font-weight: bold;
    border: 1px solid #2196f3;
  }

  .child-group-badge {
    background-color: #f3e5f5;
    color: #7b1fa2;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.8em;
    border: 1px solid #9c27b0;
  }

  .parent-group-badge {
    background-color: #fff3e0;
    color: #f57c00;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.8em;
    border: 1px solid #ff9800;
  }

  .hierarchy-group-badge {
    background-color: #e8f5e8;
    color: #2e7d32;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.8em;
    font-weight: bold;
    border: 1px solid #4caf50;
  }

  .other-group-badge {
    background-color: #f5f5f5;
    color: #666;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.8em;
    border: 1px solid #ddd;
  }

  .options-column {
    width: 220px !important;
    white-space: nowrap;
    padding: 0.3em !important;
  }

  .ui.message {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    margin: 0;
    padding: 1.5em;
    min-width: 300px;
    max-width: 500px;
    text-align: center;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    border-radius: 8px;
  }

  .ui.message .close.icon {
    position: absolute;
    top: 0.8em;
    right: 0.8em;
    cursor: pointer;
    opacity: 0.7;
  }

  .ui.message .close.icon:hover {
    opacity: 1;
  }

  .ui.message .header {
    margin-bottom: 0.5em;
    font-weight: bold;
  }

  /* Estilos para la paginación */
  .ui.pagination.menu {
    border-radius: 0.28571429rem;
    box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
  }

  .ui.pagination.menu .item {
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .ui.pagination.menu .item:hover:not(.disabled) {
    background-color: #f9fafb;
  }

  .ui.pagination.menu .item.active {
    background-color: #2185d0;
    color: white;
    font-weight: bold;
  }

  .ui.pagination.menu .item.disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .ui.pagination.menu .item.disabled:hover {
    background-color: transparent;
  }
  @media (max-width: 768px) {
    .playerlist th,
    .playerlist td {
      font-size: 12px;
      padding: 6px;
    }

    .playerlist .ui.button {
      font-size: 10px;
      padding: 4px 6px;
    }

    .playerlist .name-column,
    .playerlist .email-column,
    .playerlist .phone-column,
    .playerlist .group-column {
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .playerlist .ui.small.button {
      font-size: 9px !important;
      padding: 3px 4px !important;
    }
  }
</style>